import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route, NavLink } from 'react-router-dom';
import ChannelsPage from './routes/Channels';
import ComposePage from './routes/Compose';
import HistoryPage from './routes/History';
import AnalyticsPage from './routes/Analytics';
import PrivacyPage from './routes/Privacy';
import TermsPage from './routes/Terms';

function Layout({ children }: { children: React.ReactNode }) {
  return (
    <div style={{ fontFamily: 'system-ui, sans-serif', padding: '1.5rem', maxWidth: 960, margin: '0 auto', minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
      <header style={{ display: 'flex', gap: '1rem', marginBottom: '1.5rem', borderBottom: '1px solid #ddd', paddingBottom: '0.75rem' }}>
        <strong>Crosspost</strong>
        <NavLink to="/channels">Channels</NavLink>
        <NavLink to="/compose">Compose</NavLink>
        <NavLink to="/history">History</NavLink>
        <NavLink to="/analytics">Analytics</NavLink>
      </header>
      <main style={{ flex: 1 }}>{children}</main>
      <footer style={{ marginTop: '2rem', paddingTop: '1rem', borderTop: '1px solid #ddd', fontSize: '0.875rem', color: '#666', display: 'flex', gap: '1rem' }}>
        <span>&copy; {new Date().getFullYear()} Social Crossposter</span>
        <NavLink to="/privacy" style={{ color: '#666', textDecoration: 'none' }}>Privacy Policy</NavLink>
        <NavLink to="/terms" style={{ color: '#666', textDecoration: 'none' }}>Terms of Service</NavLink>
      </footer>
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <Layout>
        <Routes>
          <Route path="/" element={<ChannelsPage />} />
          <Route path="/channels" element={<ChannelsPage />} />
          <Route path="/compose" element={<ComposePage />} />
          <Route path="/history" element={<HistoryPage />} />
          <Route path="/analytics" element={<AnalyticsPage />} />
          <Route path="/privacy" element={<PrivacyPage />} />
          <Route path="/terms" element={<TermsPage />} />
        </Routes>
      </Layout>
    </BrowserRouter>
  );
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);